<h1 class="page-title mb-5">القطاعات المستهدفة</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="sectors-grid">
          <div class="sector-card" *ngFor="let sector of sectors" [routerLink]="sector.route">
            <div class="sector-card-inner" [style.background-image]="'url(' + sector.bg + ')'">
              <div class="sector-overlay">
                <div class="sector-icon">
                  <img [src]="sector.icon" [alt]="sector.title" />
                </div>
                <div class="sector-title">
                  <span>{{ sector.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fixed-sectors></app-fixed-sectors>
      </div>
    </div>
  </div>
</div>